/**
 * Apply Form Module
 *
 * @file applyForm.js
 */
const applyForm = (() => {
  /**
   *
   * @param {string} name
   */
  const userPasswordShow = () => {
    const toggleButtons = document.querySelectorAll('.toggle-password');

    toggleButtons.forEach(button => {
      button.addEventListener('click', () => {
        const passwordInput = button.previousElementSibling; // Butonun hemen önceki kardeşi olan input
        if (passwordInput && passwordInput.classList.contains('pass-show-hide')) {
          if (passwordInput.type === 'password') {
            passwordInput.type = 'text'; // Şifreyi göster
          } else {
            passwordInput.type = 'password'; // Şifreyi gizle
          }
        }
      });
    });
  };

  const userPhoneMask = () => {
    const applyMask = () => {
      const phoneInputs = document.querySelectorAll('.phone-mask');
    
      phoneInputs.forEach(phoneInput => {
        if (phoneInput.dataset.maskBound) return;
        phoneInput.dataset.maskBound = 'true';

        phoneInput.addEventListener('input', function(event) {
          let value = event.target.value.replace(/\D/g, ''); // Yalnızca sayıları al
    
          // Başta "0" olmalı
          if (value.length > 0 && value[0] !== '0') {
            value = '0' + value;
          }
          if (value.length > 11) {
            value = value.slice(0, 11);
          }
    
          // Telefon numarasını formatlayalım: 0XXX XXX XX XX
          let formatted = value;
          if (value.length > 4) {
            formatted = value.slice(0, 4) + ' ' + value.slice(4);
          }
          if (value.length > 7) {
            formatted = value.slice(0, 4) + ' ' + value.slice(4, 7) + ' ' + value.slice(7);
          }
          if (value.length > 9) {
            formatted = value.slice(0, 4) + ' ' + value.slice(4, 7) + ' ' + value.slice(7, 9) + ' ' + value.slice(9);
          }
    
          event.target.value = formatted; // Güncellenmiş değeri input'a set et
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', applyMask);
    } else {
      applyMask();
    }
  };
  
  const userAutPhone = () => {
    document.addEventListener('DOMContentLoaded', () => {
      const inputs = document.querySelectorAll('.one-number-inp');
    
      // Eğer .one-number-inp sınıfına sahip input'lar varsa işlemi başlat
      if (inputs.length > 0) {
        inputs.forEach((input, index) => {
          input.addEventListener('input', (event) => {
            const value = event.target.value;
    
            // Sadece sayılara izin ver, harf veya özel karakter girmeyi engelle
            if (!/^\d*$/.test(value)) {
              event.target.value = ''; // Geçersiz karakter varsa, input'u temizle
            }
    
            // Sadece sayı girildiyse ve bu son input değilse, bir sonraki input'a odaklan
            if (value && /^\d$/.test(value) && index < inputs.length - 1) {
              inputs[index + 1].focus(); // Sadece sayıya odaklan
            }
          });
    
          // Geri tuşuna basıldığında bir önceki input'a odaklan
          input.addEventListener('keydown', (event) => {
            if (event.key === 'Backspace' && !event.target.value && index > 0) {
              inputs[index - 1].focus();
            }
          });
        });
      }
    });
  };

  const clickToActiveButton = () => {
    const buttons = document.querySelectorAll('.click-to-active button, .click-to-active a');
    buttons.forEach(button => {
        button.addEventListener('click', () => {
            if (button.classList.contains('active')) {
                button.classList.remove('active');
            } else {
                button.classList.add('active');
            }
        });
    });

  };

  const foundationMemberValidation = () => {
    // function handleMenuClick() {
    //   const menuItems = document.querySelectorAll('[data-tab-toggle]');

    //   menuItems.forEach(item => {
    //       item.addEventListener('click', function (event) {
    //           event.preventDefault();

    //           const previousActiveItem = document.querySelector('.user-left-menu-item.active');
    //           const previousActiveTab = document.querySelector('.user-tab-c-content:not(.hidden)');

    //           if (previousActiveTab) {
    //               const requiredFields = previousActiveTab.querySelectorAll('input[required], select[required], textarea[required]');
    //               let hasError = false;

    //               requiredFields.forEach(field => {
    //                   if (!field.value.trim()) {
    //                       field.classList.add('error');
    //                       hasError = true;
    //                       const parentCard = field.closest('.user-tab-c-content');
    //                       const correspondingMenuItem = document.querySelector(`.user-left-menu-item[data-tab-toggle="#${parentCard.id}"]`);
    //                       if (correspondingMenuItem) {
    //                           correspondingMenuItem.classList.add('error-menu');
    //                       }
    //                   } else {
    //                       field.classList.remove('error');
    //                       const parentCard = field.closest('.user-tab-c-content');
    //                       const correspondingMenuItem = document.querySelector(`.user-left-menu-item[data-tab-toggle="#${parentCard.id}"]`);
    //                       if (correspondingMenuItem) {
    //                           correspondingMenuItem.classList.remove('error-menu');
    //                       }
    //                   }
    //               });
    //           }

    //           menuItems.forEach(menu => menu.classList.remove('active'));
    //           this.classList.add('active');

    //           const cards = document.querySelectorAll('.user-tab-c-content');
    //           cards.forEach(card => card.classList.add('hidden'));

    //           const targetId = this.getAttribute('data-tab-toggle');
    //           const targetCard = document.querySelector(targetId);
    //           if (targetCard) {
    //               targetCard.classList.remove('hidden');
    //           }
    //       });
    //   });
    // }

    // function addActiveClassToNextSection() {
    //   const buttons = document.querySelectorAll('.next-section');

    //   buttons.forEach(button => {
    //       button.addEventListener('click', function () {
    //           const parentDiv = this.closest('.user-tab-c-content');
    //           const inputs = parentDiv.querySelectorAll('input[required], select[required]');

    //           const errorMenuItem = document.querySelector(`.user-left-menu-item[data-tab-toggle="#${parentDiv.id}"]`);
    //           inputs.forEach(input => {
    //               if (!input.value.trim()) {
    //                   input.classList.add('error');
    //                   errorMenuItem.classList.add('error-menu');
    //               } else {
    //                   input.classList.remove('error');
    //                   errorMenuItem.classList.remove('error-menu');
    //               }
    //           });

    //           const nextDiv = parentDiv.nextElementSibling;

    //           if (parentDiv) {
    //               parentDiv.classList.add('hidden');
    //           }

    //           if (nextDiv) {
    //               nextDiv.classList.remove('hidden');
    //           }

    //           const targetId = nextDiv.id;

    //           document.querySelectorAll('.user-left-menu-item').forEach(item => item.classList.remove('active'));

    //           const correspondingMenuItem = document.querySelector(`.user-left-menu-item[data-tab-toggle="#${targetId}"]`);
    //           if (correspondingMenuItem) {
    //               correspondingMenuItem.classList.add('active');
    //           }
    //       });
    //   });
    // }

    // addActiveClassToNextSection();
    // handleMenuClick();

  };

  const formPasswordDigit = () => {
    document.addEventListener("DOMContentLoaded", function() {
      const passwordInput = document.getElementById('pt-password');
      const passwordCheckInput = document.getElementById('pt-password-check');
      const passwordRules = document.querySelectorAll('.input-password-type-filter .type');

      function validatePassword() {
          const password = passwordInput.value;
          let isValid = true;

          passwordRules.forEach(rule => {
              rule.classList.remove('green', 'red');
          });

          if (password.length >= 6) {
              passwordRules[1].classList.add('green');
          } else {
              passwordRules[1].classList.add('red');
              isValid = false;
          }

          if (/[A-Z]/.test(password)) {
              passwordRules[2].classList.add('green');
          } else {
              passwordRules[2].classList.add('red');
              isValid = false;
          }

          if (/[a-z]/.test(password)) {
              passwordRules[3].classList.add('green');
          } else {
              passwordRules[3].classList.add('red');
              isValid = false;
          }

          if (/[\W_]/.test(password)) {
              passwordRules[4].classList.add('green');
          } else {
              passwordRules[4].classList.add('red');
              isValid = false;
          }

          return isValid;
      }

      function validatePasswordMatch() {
          const password = passwordInput.value;
          const passwordCheck = passwordCheckInput.value;

          const matchMessage = document.querySelector('.input-password-type-filter .type:first-child');

          if (password === passwordCheck) {
              matchMessage.classList.remove('red');
              matchMessage.classList.add('green');
              matchMessage.textContent = "Yeni Şifre ile aynı";
          } else {
              matchMessage.classList.remove('green');
              matchMessage.classList.add('red');
              matchMessage.textContent = "Yeni Şifre İle Eşleşmiyor";
          }
      }
      if(passwordInput){
        passwordInput.addEventListener('input', function() {
            validatePassword();
            validatePasswordMatch();
        });

        passwordCheckInput.addEventListener('input', function() {
            validatePasswordMatch();
        });
      }
    });
  };

  const customFileInput = () => {
    document.addEventListener('DOMContentLoaded', () => {
      const fileInputs = document.querySelectorAll('.custom-file-input-container input[type="file"]');

      fileInputs.forEach((fileInput) => {
        fileInput.addEventListener('change', function(event) {
          const file = event.target.files[0];
          const container = this.closest('.custom-file-input-container');
          const docNameElement = container?.querySelector('.doc-name');
          
          if (file && docNameElement) {
            docNameElement.textContent = file.name;
          }
        });
      });
    });
  };

  /**
   * init module
   */
  const init = () => {
    userPasswordShow();
    userPhoneMask();
    userAutPhone();
    clickToActiveButton();
    foundationMemberValidation();
    formPasswordDigit();
    customFileInput();
  };

  return {
    init,
  };
})();

export default applyForm;
